module.exports = __webpack_public_path__ + "img/841020315.10e57479.jpg";